export default {
  actions: {
    createPressLink({ dispatch, commit }, { organization, formData }) {
      this.$authorize('edit', 'Organization')

      return Vue.$http
        .post(`admin/organizations/${organization.id}/press_links`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        })
        .then(
          () => dispatch('fetch', organization.id),
          () => commit('snackbar', { text: 'Press link could not be added', type: 'error' }, { root: true })
        )
    },
    removePressLink({ dispatch, commit }, { organization, pressLink }) {
      this.$authorize('edit', 'Organization')

      return Vue.$http
        .delete(`admin/organizations/${organization.id}/press_links/${pressLink.id}`)
        .then(
          () => dispatch('fetch', organization.id),
          () => commit('snackbar', { text: 'Photo could not be removed', type: 'error' }, { root: true })
        )
    }
  }
}
